export default "/images/exchange.png?629686d610571c6e9bf49ac2d58ef247";